<script>
import { mapState } from 'vuex'
import Action from '@/components/Action'
import Icon from '@/components/Icon'

const FALLBACK_MESSAGE = 'Conta bloqueada. Entre em contato com o suporte.'

export default {
  name: 'AccountBlocked',

  components: {
    Action,
    Icon,
  },

  data () {
    return {
      code: null,
      message: null,
    }
  },

  computed: {
    ...mapState('auth', ['token']),

    isAuthenticated () {
      return !!this.token
    },
  },

  created () {
    const raw = sessionStorage.getItem('blockedReason')
    if (!raw) {
      this.$router.replace({ name: this.isAuthenticated ? 'home' : 'auth.login' }).catch(() => {})
      return
    }
    try {
      const data = JSON.parse(raw)
      this.code = data.code
      this.message = data.message || FALLBACK_MESSAGE
    } catch {
      this.message = FALLBACK_MESSAGE
    } finally {
      sessionStorage.removeItem('blockedReason')
    }
  },

  methods: {
    goToLogin () {
      this.$router.replace({ name: 'auth.login' }).catch(() => {})
    },
  },
}
</script>

<template>
  <div :class="$classes['container']" role="main">
    <action :to="{ name: 'auth.login' }" :class="$classes['logo-link']">
      <img src="@/assets/images/logo.png" :class="$classes['logo']" alt="Scherer Autopeças">
    </action>
    <section :class="$classes['card']" role="status" aria-live="polite" aria-label="Conta bloqueada">
      <div :class="$classes['blocked-container']">
        <div :class="$classes['blocked-icon']" aria-hidden="true">
          <icon name="lock" :class="$classes['blocked-icon-icon']" />
        </div>
        <h1 :class="$classes['blocked-title']">
          Conta bloqueada
        </h1>
        <p :class="$classes['blocked-message']">
          {{ message }}
        </p>
        <action full-width :class="$classes['card-btn']" variant="contained" color="primary" @click="goToLogin">
          Voltar ao login
        </action>
      </div>
    </section>
  </div>
</template>

<style module>
.container {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #fff 20%, #ccc 100%);
  padding: 30px 20px;
}

.blocked-icon {
  width: 36px;
  height: 36px;
}

.logo-link {
  display: contents;
}

.logo {
  position: absolute;
  top: 30px;
  height: 70px;
  width: auto;
}

.card {
  width: 100%;
  max-width: 340px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .04), 0 4px 16px -4px rgba(0, 0, 0, .16);
  padding: 36px 40px;
}

.card-btn {
  gap: 16px;
  min-height: 44px;
}

.blocked-container {
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  animation: blockedFadeIn 0.35s ease-out;
}

@keyframes blockedFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.blocked-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #EC535E;
  color: #fff;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  animation: blockedIconPop 0.4s ease-out;
}

@keyframes blockedIconPop {
  from {
    transform: scale(0);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.blocked-title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 0;
  color: #1a1a1a;
}

.blocked-message {
  font-size: 0.9375rem;
  line-height: 1.5;
  color: #555;
  margin-bottom: 28px;
}

@media (max-width: 767px) {
  .logo {
    height: 50px;
    top: 20px;
  }

  .card {
    box-shadow: none;
    padding: 24px 20px;
  }
}
</style>
